import { BrowserRouter } from "react-router-dom";
import { PermissionDeniedModal } from "@/components/PermissionDeniedModal";
import { Toaster } from "@/components/ui/toaster";
import { AntdConfigProvider } from "@/contexts/AntdConfigProvider";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AppRoutes } from "@/router";
import { useAuthStore } from "@/store/auth.store";
import { RequestErrorNotifier } from '@/components/RequestErrorNotifier';

function App() {
  const hasHydrated = useAuthStore((state) => state._hasHydrated);

  if (!hasHydrated) {
    return null;
  }

  return (
    <ThemeProvider>
      <AntdConfigProvider>
        <BrowserRouter>
          <Toaster />
          <RequestErrorNotifier />
          <PermissionDeniedModal />
          <AppRoutes />
        </BrowserRouter>
      </AntdConfigProvider>
    </ThemeProvider>
  );
}

export default App;
